//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifSysEdit: {
      type: Boolean,
      default: false
    },
    formSysdata: null
  },
  data: function data() {
    return {
      formSys: {
        systemId: null,
        systemName: null
      },
      formSysdefault: {
        systemId: null,
        systemName: null
      },
      rules: {
        systemId: [{
          required: true,
          message: '请输入编号',
          trigger: 'blur'
        }],
        systemName: [{
          required: true,
          message: '请输入系统名称',
          trigger: 'blur'
        }],
        isPublicResource: [{
          required: true,
          message: '请选择是否是公共系统',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    if (this.ifSysEdit) {
      this.formSys = this.formSysdata;
    } else {
      this.formSys = this.formSysdefault;
    }
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('cancelSysEdit');
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    },
    commit: function commit() {
      var _this = this;
      this.$refs.formSys.validate(function (valid) {
        if (valid) {
          if (!_this.ifSysEdit) {
            _this.formSys.defaultDomain = window.location.origin;
          }
          _this.$emit('sysEditSubmit', {
            bool: true,
            formData: _this.formSys
          });
        } else {
          _this.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
      // this.$emit('sysEditSubmit', { bool: true, formData: this.formSys})
    }
  }
};